















































import { Component, Vue } from "vue-property-decorator";
import { getStyleUsage } from "@/services/styles/stylesService";
import { StyleUsage } from "@/services/styles/types";

@Component
export default class StyleUsageModal extends Vue {
    // local state
    styleUsage = {} as StyleUsage;
    // methods
    open(styleId: string) {
        getStyleUsage(styleId).then((resp: StyleUsage) => {
            this.styleUsage = resp;
            this.$bvModal.show("modal-usage");
        });
    }

    close() {
        this.$bvModal.hide("modal-usage");
    }

    goToChannelGroup(channelGroupId: string) {
        return {
            name: "UpdateChannelGroup",
            params: {
                channelGroupId: channelGroupId
            }
        };
    }

    goToChannel(channelId: string) {
        return {
            name: "updatechannel",
            params: { channelId: channelId }
        };
    }
}
